function BlackList() {
    return (
      <>
        <div className="font-bold text-lg mb-16">BlackList</div>
      </>
    );
  }
  
  export default BlackList;